import { render, staticRenderFns } from "./App-bar-desktop.vue?vue&type=template&id=527faa0e&scoped=true&"
import script from "./App-bar-desktop.vue?vue&type=script&lang=js&"
export * from "./App-bar-desktop.vue?vue&type=script&lang=js&"
import style0 from "./App-bar-desktop.vue?vue&type=style&index=0&id=527faa0e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527faa0e",
  null
  
)

export default component.exports